//
// Imports
//

import { initialiseBlocks } from "./components/blocks/Block.client.js";

import
{ 
	initialiseGlobalAudioPlayers,
	initialiseGlobalAudioPlayerPlayButtons,
} from "./components/globals/GlobalAudioPlayer.client.js";

import { initialisePjax } from "./libs/Pjax.client.js";

//
// Client
//

declare global
{
	interface DocumentEventMap
	{
		"mpa:reinitialize": CustomEvent<null>;
	}
}; 

async function initialise()
{
	//
	// Components
	//

	// Blocks
	initialiseBlocks();

	// Globals
	initialiseGlobalAudioPlayers();
	initialiseGlobalAudioPlayerPlayButtons();

	//
	// Libs
	//

	initialisePjax();
}

initialise();

document.addEventListener("mpa:reinitialize", () => initialise());